module.exports = __webpack_public_path__ + "static/media/vector1_1.22ad4c16.png";